<template>
    <v-container pa-0>
        <v-container class="text-center" mt-4 mb-4>
            <v-icon color="success" large v-if="success">
                mdi-check-all
            </v-icon>
            <v-icon color="error" large v-else>
                mdi-close
            </v-icon>
        </v-container>

        <h1 class="">
            {{ $vuetify.lang.t(title) }}
        </h1>
        <p class="body-1 mb-2">
            {{ $vuetify.lang.t(description) }}
        </p>

        <div class="body-1">
            <v-row v-if="success">
                <v-col class="pb-0">{{ $vuetify.lang.t('$vuetify.transaction_labels.model_name') }}</v-col>
                <v-col class="pb-0 title" cols="auto">{{ contract.model_name }}</v-col>
            </v-row>
            <v-row v-if="success">
                <v-col class="pt-0 pb-0">{{ $vuetify.lang.t('$vuetify.transaction_labels.vin') }}</v-col>
                <v-col class="pt-0 pb-0 text-uppercase" cols="auto">{{ contract.vin }}</v-col>
            </v-row>
            <v-row v-if="success">
                <v-col class="pt-0">{{ $vuetify.lang.t('$vuetify.form_items.contract_date') }}</v-col>
                <v-col class="pt-0" cols="auto">{{ contract.order_date_customer | date }}</v-col>
            </v-row>

            <v-row v-if="success">
                <v-col class="pb-0">{{ $vuetify.lang.t('$vuetify.add_contract.increase_points') }}</v-col>
                <v-col class="pb-0 title  font-weight-bold" cols="auto">{{ balance_increase | number }} {{ $vuetify.lang.t('$vuetify.points.medium') }}</v-col>
            </v-row>
            <v-row v-if="success && isInstantApproved">
                <v-col class="pt-0">{{ $vuetify.lang.t('$vuetify.add_contract.new_account_balance') }}</v-col>
                <v-col class="pt-0 title  font-weight-bold" cols="auto">{{ current_balance | number }} {{ $vuetify.lang.t('$vuetify.points.medium') }}</v-col>
            </v-row>
            <v-row v-else-if="success && isOwner">
                <v-col class="pt-0">{{ $vuetify.lang.t('$vuetify.add_contract.account_balance_after_finance') }}</v-col>
                <v-col class="pt-0 title  font-weight-bold" cols="auto">{{ current_balance + balance_increase | number }} {{ $vuetify.lang.t('$vuetify.points.medium') }}</v-col>
            </v-row>
            <v-row v-else-if="success">
                <v-col class="pt-0">{{ $vuetify.lang.t('$vuetify.add_contract.account_balance_after_approval') }}</v-col>
                <v-col class="pt-0 title font-weight-bold" cols="auto">{{ current_balance + balance_increase | number }} {{ $vuetify.lang.t('$vuetify.points.medium') }}</v-col>
            </v-row>
        </div>

        <ul v-if="errors.length > 0">
            <li v-for="error in errors" class="body-1" v-html="error"></li>
        </ul>
    </v-container>
</template>
<script>
    export default {
        name: 'submit-contract-result',
        props: {
            user: {
                type: Object,
            },
            success: {
                type: Boolean,
            },
            errors: {
                type: Array,
            },
            contract: {
                type: Object,
            },
            balance_increase: {
                type: Number,
            },
            current_balance: {
                type: Number,
            },
            isInstantApproved: {
                type: Boolean,
            },
        },
        computed: {
            isOwner() {
                return this.user.role === 'owner';
            },
            title() {
                if (this.errors.length > 0) {
                    return '$vuetify.add_contract.error_headline';
                }
                if (this.isInstantApproved) {
                    return '$vuetify.add_contract.success_owner_headline';
                }
                if (this.isOwner) {
                    return '$vuetify.add_contract.success_owner_financing_headline';
                }
                return '$vuetify.add_contract.success_headline';
            },
            description() {
                if (this.errors.length > 0) {
                    return '$vuetify.add_contract.error_desc';
                }
                if (this.isInstantApproved) {
                    return '$vuetify.add_contract.success_owner_desc';
                }
                if (this.user.role === 'owner') {
                    return '$vuetify.add_contract.success_owner_financing_desc';
                }
                return '$vuetify.add_contract.success_desc';
            },
        },
    }
</script>
